import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/rv/rect.png'
import _imports_1 from '@/assets/images/rv/upload.svg'


const _withScopeId = n => (_pushScopeId("data-v-b919a4e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "condition" }, [
  /*#__PURE__*/_createElementVNode("section", null, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      class: "rect"
    }),
    /*#__PURE__*/_createElementVNode("strong", { class: "wrap-title" }, "核对"),
    /*#__PURE__*/_createElementVNode("span", { class: "m-l-6" }, "（若拒绝，请填写拒绝理由并提交）")
  ])
], -1))
const _hoisted_2 = { class: "m-t-10 check-part" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("确认")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("拒绝")
const _hoisted_5 = { class: "m-t-10" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "拒绝理由（限定100字）", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "condition" }, [
  /*#__PURE__*/_createElementVNode("section", null, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      class: "rect"
    }),
    /*#__PURE__*/_createElementVNode("strong", { class: "wrap-title" }, "上传盖章版经销商折让明细：")
  ])
], -1))
const _hoisted_8 = { class: "clearfix" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ant-upload-drag-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    class: "uploadIcon"
  })
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ant-upload-text" }, [
  /*#__PURE__*/_createTextVNode(" 拖拽文件或 "),
  /*#__PURE__*/_createElementVNode("span", { class: "blueFont" }, "点击此处浏览文件上传")
], -1))
const _hoisted_11 = { style: {"margin-top":"10px"} }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { style: {
          position: 'absolute',
          right: 0,
          bottom: 0,
          width: '100%',
          borderTop: '1px solid #e9e9e9',
          padding: '10px 16px',
          background: '#fff',
          textAlign: 'right',
          zIndex: 1,
      } }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("提交")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_upload_dragger = _resolveComponent("a-upload-dragger")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_drawer = _resolveComponent("a-drawer")!
  const _component_comment_modal = _resolveComponent("comment-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_drawer, {
      title: _ctx.title,
      closable: true,
      visible: _ctx.isUploadVisible,
      width: "35.14%",
      onClose: _ctx.close
    }, {
      default: _withCtx(() => [
        _hoisted_1,
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_a_radio_group, {
            value: _ctx.check,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.check) = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_radio, { value: "upload" }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }),
              _createVNode(_component_a_radio, { value: "reject" }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["value"])
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode(_component_a_textarea, {
            value: _ctx.comment,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.comment) = $event)),
            showCount: "",
            maxlength: 100,
            placeholder: "请输入"
          }, null, 8, ["value"])
        ], 512), [
          [_vShow, _ctx.check === 'reject']
        ]),
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_a_upload_dragger, {
            name: "file",
            multiple: true,
            showUploadList: true,
            remove: _ctx.handleRemove,
            "before-upload": _ctx.beforeUpload,
            onChange: _ctx.fileChange,
            "file-list": _ctx.fileList,
            "onUpdate:file-list": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.fileList) = $event))
          }, {
            default: _withCtx(() => [
              _hoisted_9,
              _hoisted_10
            ]),
            _: 1
          }, 8, ["remove", "before-upload", "onChange", "file-list"])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_a_table, {
            columns: _ctx.attachmentColumns,
            pagination: false,
            dataSource: _ctx.myAttachmentData,
            rowKey: "id",
            bordered: ""
          }, {
            action: _withCtx(({ record }) => [
              _createElementVNode("a", null, [
                _createElementVNode("span", {
                  class: "font_family",
                  style: {"font-size":"16px"},
                  onClick: ($event: any) => (_ctx.downloadAttachment(record))
                }, "下载", 8, _hoisted_12)
              ])
            ]),
            comment: _withCtx(({ record }) => [
              _createElementVNode("span", {
                class: _normalizeClass(['font_family icon-Comment', record.commentList.length > 0 ? 'link cursor-p' : 'color-g']),
                style: {"font-size":"16px"},
                onClick: ($event: any) => (_ctx.openComment(record))
              }, null, 10, _hoisted_13)
            ]),
            _: 1
          }, 8, ["columns", "dataSource"])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_a_button, {
            style: {"margin-right":"8px"},
            onClick: _ctx.close
          }, {
            default: _withCtx(() => [
              _hoisted_15
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_a_button, {
            type: "primary",
            loading: _ctx.uploading,
            onClick: _ctx.uploadClick
          }, {
            default: _withCtx(() => [
              _hoisted_16
            ]),
            _: 1
          }, 8, ["loading", "onClick"])
        ])
      ]),
      _: 1
    }, 8, ["title", "visible", "onClose"]),
    _createVNode(_component_comment_modal, {
      visible: _ctx.commentVisible,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.commentVisible) = $event)),
      commentData: _ctx.commentData
    }, null, 8, ["visible", "commentData"])
  ], 64))
}